/**
 * メール配信先
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as ShopActions from "src/state/ducks/shop/actions";
import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";
import MailSenderForm from "src/components/organisms/form/MailSenderForm";

type OwnProps = {
  id: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class ShopMailSenderCreatePage extends Component<Props> {
  componentDidMount() {
    this.props.getShop(this.props.login_shop_id);
  }

  onCreate = (address: string) => {
    const { login_shop_id, updateMailSenders } = this.props;
    updateMailSenders(login_shop_id, "add", address);
  };

  render() {
    const { isFetching, isUpdateMailSendersSuccess } = this.props;
    if (
      this.props.shop.id !== "" &&
      this.props.login_shop_id !== this.props.shop.id
    ) {
      return (
        <Redirect
          to={{
            pathname: "/error",
            state: { errCode: 403 },
          }}
        />
      );
    }
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <SpinnerModal isLoading={isFetching} />
          <Heading
            text={"取り置き注文の通知を受け取るメールアドレスを登録する"}
          />
          <MailSenderForm
            login_shop_id={this.props.login_shop_id}
            address={""}
            onSubmit={this.onCreate}
            errors={this.props.validationErros}
            isSuccess={isUpdateMailSendersSuccess}
          />
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
`;

const mapStateToProps = (state: State, OwnProps: OwnProps) => ({
  shop: state.shop.currentShop.resource,
  isFetching: state.shop.currentShop.isFetching,
  isUpdateMailSendersSuccess: state.shop.currentShop.isUpdateMailSendersSuccess,
  validationErros: state.shop.currentShop.validationErrors,
  apiErrors: state.shop.currentShop.apiError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getShop: (document_id: string) => dispatch(ShopActions.getShop(document_id)),
  updateMailSenders: (
    document_id: string,
    method: "add" | "delete",
    address: string
  ) =>
    dispatch(
      ShopActions.updateMailSenders({
        doc_id: document_id,
        method: method,
        address: address,
      })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShopMailSenderCreatePage);
